import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { StartupService } from '../services/startup.service';

export function provideStartup(): EnvironmentProviders {
  return provideAppInitializer(async () => {
    const startup = inject(StartupService);
    return await startup.init();
  });
}
